import { COMBINED_MODES } from "@sop/OperationsTimelinePage/Timeline/OperationsTimelineContent"
import { queryOptions } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { OpModeGetListArgs, OpModeList, endpoints } from "api"

export function opModesQueryOptions({ plantIdsList }: { plantIdsList?: number[] }) {
	const queryKey = [
		`queryId=GetOpModesList`,
		`endpoints=[${endpoints.opModeGetList.getName()}]`,
		`plantIdsList=[${plantIdsList}]`,
	]

	return queryOptions({
		queryKey,
		queryFn: async (): Promise<
			| {
					id: number | string
					name: string
			  }[]
			| null
			| undefined
		> => {
			if (plantIdsList === undefined || plantIdsList.length === 0) {
				return undefined
			}

			const data: OpModeList = []
			const seenIds = new Set<number>()

			for (const plantId of plantIdsList) {
				if (plantId === -1 || plantId === undefined) {
					continue
				}

				try {
					const args: OpModeGetListArgs = { plantId: plantId }
					const opModes = await requestApi2(endpoints.opModeGetList, args)
					if (opModes !== null && Array.isArray(opModes)) {
						for (const opMode of opModes) {
							if (!seenIds.has(opMode.id)) {
								seenIds.add(opMode.id)
								data.push(opMode)
							}
						}
					} else {
						console.error(`Invalid response for plantId ${plantId}:`, opModes)
					}
				} catch (error) {
					console.error(`Error fetching op modes for plantId ${plantId}:`, error)
					return undefined
				}
			}

			return [
				...(data ?? []),
				{ name: `All`, id: "all" },
				...COMBINED_MODES.filter((mode) => {
					if (data !== undefined && data !== null) {
						return data?.filter((a) => a.name.toLowerCase().includes(mode.refString))
							.length > 1
							? true
							: false
					}
					return false
				}).map((mode) => ({
					name: mode.name,
					id: mode.id,
				})),
			].sort((a, b) => {
				if (a.name === `All`) return -1
				if (b.name === `All`) return 1
				return a.name.localeCompare(b.name)
			})
		},
		staleTime: 600000,
		refetchInterval: 600000,
	})
}
